import { render, staticRenderFns } from "./StandUpdate.vue?vue&type=template&id=a675788e"
import script from "./StandUpdate.vue?vue&type=script&lang=ts"
export * from "./StandUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports